import React from "react";
import { Box, Typography, Stack, Paper } from "@mui/material";
import { keyframes } from "@mui/system";

const shimmer = keyframes`
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;

const ShimmerBox = ({ width, height, borderRadius = 4 }) => (
    <Box
        sx={{
            width,
            height,
            borderRadius,
            background: 'linear-gradient(90deg, #3b5f7f 25%, #5c7d9d 50%, #3b5f7f 75%)',
            backgroundSize: '400px 100%',
            animation: `${shimmer} 1.5s infinite`,
        }}
    />
);

export default function UserStatsCardSkeletonWeb({ vrProgress }) {
    return (
        <Paper sx={{ p: 3, borderRadius: 3, mb: 3, position: "relative", bgcolor: '#294e6b', color: "#fff" }}>
            {/* VR Progress */}
            {vrProgress && (
                <Box mb={2} textAlign="center">
                    <Typography>Rozpoczęto scenariusz VR {vrProgress.scenario}</Typography>
                    <Typography>Progress: {vrProgress.progress}%</Typography>
                </Box>
            )}

            {/* HEADER */}
            <Stack direction="row" justifyContent="space-between" mb={2}>
                <ShimmerBox width={130} height={20} borderRadius={4} />
                <ShimmerBox width={100} height={18} borderRadius={4} />
            </Stack>

            {/* CONTENT */}
            <Stack direction="row" spacing={4} alignItems="center">
                <Box width={180} height={90} borderRadius={2} overflow="hidden" bgcolor="#3b5f7f" position="relative">
                    <ShimmerBox width="100%" height="100%" borderRadius={2} />
                </Box>

                <Box flex={1}>
                    <ShimmerBox width={100} height={16} mb={1} />
                    <ShimmerBox width={80} height={14} mb={2} />
                    <Stack direction="row" spacing={1}>
                        {[1, 2, 3].map(i => (
                            <Box key={i} width={50} height={24} borderRadius={2} bgcolor="#3b5f7f" overflow="hidden" position="relative">
                                <ShimmerBox width="100%" height="100%" borderRadius={2} />
                            </Box>
                        ))}
                    </Stack>
                </Box>
            </Stack>

            {/* FOOTER */}
            <Box mt={2} textAlign="center">
                <ShimmerBox width={120} height={14} borderRadius={4} />
            </Box>
        </Paper>
    );
}
